export default __webpack_public_path__ + "static/pic03-9c62e79af3f286af79577eda5c894ac6.jpg";